// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","447":"admin-usage"}[chunkId] + "." + {"328":"4437ead4","447":"344deda1"}[chunkId] + ".css";
};